import React from 'react';
import { Button, Typography, Card, CardContent, List, ListItem, ListItemText, FormControlLabel } from '@mui/material';

interface RoleDetailsProps {
  selectedRole: any | null;
  onDelete: () => void;
  onEdit: (isNew: boolean, role: any) => void;
}

const RoleDetails: React.FC<RoleDetailsProps> = ({ selectedRole, onDelete, onEdit }) => {
  if (!selectedRole) {
    return (
      <Card className="flex justify-center items-center h-full p-4">
        <Typography variant="body1" color="textSecondary">
          Select a role to view details
        </Typography>
      </Card>
    );
  }

  return (
    <Card className="p-4">
      <CardContent>
        <Typography variant="h5" className="text-gray-800 font-semibold mb-4">
          {selectedRole.name}
        </Typography>

        <Typography variant="subtitle1" className="text-gray-600 mb-4">
          Description
        </Typography>
        <Typography variant="body2" className="text-gray-700 mb-6">
          {selectedRole.description || 'No description provided.'}
        </Typography>

        <Typography variant="subtitle1" className="text-gray-600 mb-2">
          {selectedRole.permissions.length} assigned permissions
        </Typography>
        <List dense className="bg-gray-50 p-4 rounded-md">
        <ListItem key={103} className="p-2">
                <FormControlLabel
                control={<div>{}</div>}
               
                label={"Admin"}
              />
              <ListItemText primary={selectedRole.isAdminRole ? "Yes" : "No"} className="text-gray-500 text-sm" />
              
            </ListItem>
          {selectedRole.permissions.map((permission, index) => (
            <ListItem key={index} className="p-2">
                <FormControlLabel
                control={<div>{}</div>}
               
                label={permission}
              />
              <ListItemText primary={selectedRole.brandSecurity.permissions[permission]} className="text-gray-500 text-sm" />
              
            </ListItem>
          ))}
        </List>
      </CardContent>

      <div className="flex justify-between mt-4">
        <Button variant="contained" color="error" onClick={onDelete}>
          Delete
        </Button>
        <Button variant="contained" color="primary" onClick={()=>onEdit(false,selectedRole)}>
          Edit Role
        </Button>
      </div>
    </Card>
  );
};

export default RoleDetails;
